import { DASHBOARD_TONES } from '#/modules/infra/dashboard/helper/dashboardModules';

/** 狀態語意色說明（草稿／待處理／進行中／完成／異常） */
const DashboardToneLegend = () => (
  <ul className="flex flex-wrap gap-x-3 gap-y-1 text-xs text-muted-foreground" aria-label="狀態顏色說明">
    {Object.entries(DASHBOARD_TONES).map(([key, tone]) => (
      <li key={key} className="inline-flex items-center gap-1">
        <span className={`size-2 rounded-full ${tone.dotClass}`} aria-hidden />
        {tone.label}
      </li>
    ))}
  </ul>
);

export default DashboardToneLegend;
